<template>
  <div class="find_home" style="background:#FF4D5A;min-height: 100vh;">
    <gc-loading :is-show="loadingShow" />
    <gc-guide :down-show="downShow" @showDwon="getWechat" />
    <div class="banner" style="padding:0">
      <img src="https://static.mingchu.co/webapp/findNew/imgs/banner.png" alt="">
    </div>
    <div class="center">
      <div class="cenTitle">参与嘉宾</div>
      <div class="user_img">
        <img src="https://static.mingchu.co/webapp/findNew/imgs/avatar.png" alt="">
        <img src="https://static.mingchu.co/webapp/findNew/imgs/avatar (1).png" alt="">
        <img src="https://static.mingchu.co/webapp/findNew/imgs/avatar (2).png" alt="">
      </div>
      <div class="user_name">常龙山、杨超、张健</div>
      <div class="Number">当前已有  <span>{{ share.count }}</span>  名厨师参与</div>
      <div class="user_list"><span v-for="(item,index) in share.user" :key="index">{{ item.nick_name }}<span v-if="index!=share.user.length-1">、</span><span v-else>...</span></span></div>
      <div class="reward">
        <div class="rewardTitle">活动奖励</div>
        <div>1、与星厨同行，共赴三天两夜寻味天府之旅</div>
        <div> 2、天府食材包、名厨MINGCHU周边/积分 </div>
        <div>3、加入名厨川菜交流群，与同行切磋技艺</div>
      </div>
      <div class="immediately" @click="participate()">立即参与</div>
    </div>
    <div class="smalllogo">
      <img src="https://static.mingchu.co/webapp/findNew/imgs/Smalllogo.png" alt="">
    </div>
    <ShareInfo :share-info="shareInfo" />

  </div>
</template>
<script>
import { reactive, toRefs, onBeforeMount } from 'vue'
import { useRouter } from 'vue-router'
import utils from '@/utils/utils'
import config from '@/config/config'
import { ajaxHttp } from '@/api/api'
import ShareInfo from '@/components/shareInfo.vue'

import { Toast } from 'vant'
import gcLoading from '@/components/gc-loading'
import { platformType } from '@/utils'

export default {
  name: 'Share',
  components: {
    gcLoading,
    ShareInfo
  },
  setup() {
    const router = useRouter()
    const state = reactive({
      shareInfo: { share_title: '闯关任务开启｜寻找川菜守“味”者', share_desc: '与星厨同行，共赴天府寻味之旅！', share_img: 'https://static.mingchu.co/webapp/findNew/share1.jpg', share_link: `${config.webapplink}/riseActivity/findNew/findshare?id=0` },
      loadingShow: true,
      share: {},
      downShow: false,
      uid: 0
    })
    onBeforeMount(() => {
      sensors.track('PlanVisit', {
        PlatformType: platformType(),
        page_type: 'share'
      })
      console.log(router.currentRoute.value.query.id, router.currentRoute.value.query.sharefrom)
      Uidlist()
    })
    const Uidlist = () => {
      console.log(state.uid)
      ajaxHttp.$get(`/api/plan/share`, { uid: router.currentRoute.value.query.id }).then(res => {
        if (res.code === 1) {
          console.log(res.data)
          state.share = res.data
          state.loadingShow = false
        } else {
          state.loadingShow = false
          Toast(res.message)
        }
      })
    }
    const participate = () => {
      const u = navigator.userAgent
      const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1
      if (utils.is_weixn()) {
        if (!isAndroid) {
          utils.goDown('H5', `${config.webapplink}/riseActivity/findNew/findrule`)
        } else {
          state.downShow = true
        }
      } else {
        utils.goDown('H5', `${config.webapplink}/riseActivity/findNew/findrule`)
      }
    }
    return { ...toRefs(state), participate }
  }
}
</script>
<style lang="scss" scoped>
.center{
  width: 345px;height: 492px;background: #FFFFFF;border-radius: 8px;position: relative;top:-136px;left: 16px;
  .cenTitle{
    color: #333333;font-size: 18px;font-weight: bold;width: 100%;text-align: center;padding-top: 21px;
  }
  .user_img{margin-left:83px;margin-top:24px;height:72px;
    img{width: 72px;height: 72px;border-radius: 50%;margin-left: -13px;}
  }
  .user_name{width: 90%;margin-left: 5%;text-align: center;color: #333333;font-size: 16px;margin-top: 18px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;}
  .Number{width: 100%;text-align: center;color: #333333;font-size: 20px;font-weight: bold;margin-top:37px;
    span{
      color:#C99700;
    }
  }
  .user_list{width: 280px;margin-left: 32px;text-align: center;font-size:14px;color: #333;margin-top: 14px; display: -webkit-box;
  overflow: hidden;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;}
  .reward{width: 290px;margin-left: 27px;font-size: 12px;color: #666666;margin-top: 43px;position: absolute;bottom: 70px;
    .rewardTitle{
      font-size: 16px;font-weight: bold;padding-bottom: 4px;
    }
  }
  .immediately{position: absolute;bottom: -1px;width: 100%;height: 56px;background: #FAF5E6;border-radius: 0px 0px 8px 8px;color: #C99700;font-size: 16px;line-height: 56px;font-weight: bold;text-align: center;}
}
.smalllogo{width: 100%;height:124px;margin-top:-94px;
  img{width: 145.57px;height:60px;margin-left:114px;}
}
</style>
